import Api from '@teko/api';
import { accessTokenInterceptor } from '@teko/auth';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
class WarehouseService {
  constructor(apiUrl) {
    this.getReturnRequests = async ({
      orderId,
      terminalCode,
      discoveryService,
      platformId
    }) => {
      const { data } = await this.warehouseApi.get(`/return-requests`, {
        params: {
          orderIds: orderId,
          sortLatest: true,
          platformId
        }
      });
      const res = data == null ? void 0 : data.request;
      const allItemSkus = (res == null ? void 0 : res.reduce((skus, req) => {
        skus.push(...req.items.map((item) => item.sku));
        return skus;
      }, [])) || [];
      if (allItemSkus.length > 0) {
        const products = await discoveryService.getProductDetailBySkus({
          skus: Array.from(new Set(allItemSkus)),
          terminalCode
        });
        return res.map((req) => {
          return __spreadProps(__spreadValues({}, req), {
            items: req.items.map((item) => {
              var _a;
              const product = products.find((product2) => product2.productInfo.sku === item.sku);
              return __spreadProps(__spreadValues({}, item), {
                imageUrl: ((_a = product == null ? void 0 : product.productInfo) == null ? void 0 : _a.imageUrl) || ""
              });
            })
          });
        });
      }
      return res;
    };
    this.getReturnReasons = async (platformId, isStaffOnly) => {
      const { data } = await this.warehouseApi.get(`/return-reasons`, {
        params: {
          platformId,
          status: "RETURN_REASON_STATUS_ACTIVE",
          isStaffOnly,
          limit: 200
        }
      });
      return (data == null ? void 0 : data.reasons) || [];
    };
    this.addReturnRequest = async (orderId, requestPayload) => {
      const payload = __spreadValues({
        orderId
      }, requestPayload);
      return await this.warehouseApi.post(`/return-request`, {
        data: payload
      });
    };
    this.warehouseApi = new Api(apiUrl);
    this.warehouseApi.addInterceptor(accessTokenInterceptor);
  }
}

export { WarehouseService };
